<ion-chip color="danger" [class.--is-offline]="!(online$ | async)" (click)="showAlert()">
  <ion-icon name="cloud-offline-outline"></ion-icon>
  <ion-label color="dark" [innerHTML]="'OFFLINE.offline' | translate"></ion-label>
</ion-chip>
